import { render, staticRenderFns } from "./JVxeDemo2.vue?vue&type=template&id=64d16684&scoped=true&"
import script from "./JVxeDemo2.vue?vue&type=script&lang=js&"
export * from "./JVxeDemo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d16684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d16684')) {
      api.createRecord('64d16684', component.options)
    } else {
      api.reload('64d16684', component.options)
    }
    module.hot.accept("./JVxeDemo2.vue?vue&type=template&id=64d16684&scoped=true&", function () {
      api.rerender('64d16684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/JVxeDemo2.vue"
export default component.exports